import { useContext, useState, useEffect } from "react";
import { UserContext } from "../../components/UserContext";
import "../../App.css";
import { Navigate, useSearchParams } from "react-router-dom";
import AccountExperiencePage from "./AccountExperiencePage";
import AccountHostPage from "./AccountHostPage";

export default function AccountPage() {
  const [searchParams] = useSearchParams();
  const [isHostMode, setIsHostMode] = useState(false);
  const { user, ready } = useContext(UserContext);

  // Handle URL parameters to set initial state
  useEffect(() => {
    const mode = searchParams.get("mode");

    if (mode === "host") {
      setIsHostMode(true);
    }
  }, [searchParams]);

  if (!user) {
    return <Navigate to={"/"} />;
  }

  if (!ready) {
    return <div className="text-center py-12">Loading...</div>;
  }

  const handleToggleMode = () => {
    setIsHostMode(!isHostMode);
  };

  return (
    <div className="min-h-screen">
      {isHostMode ? (
        <AccountHostPage onToggleMode={handleToggleMode} />
      ) : (
        <AccountExperiencePage onToggleMode={handleToggleMode} />
      )}
    </div>
  );
}
